import { type ReactNode } from 'react';
import { TopBar } from '@/components/layout/TopBar';
import { PageContainer } from '@/components/layout/PageContainer';

export function OnboardingLayout({
  title,
  back,
  children,
}: {
  title?: string;
  back?: boolean;
  children: ReactNode;
}): JSX.Element {
  return (
    <PageContainer>
      <TopBar back={back} title={title} />
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16, flex: 1 }}>{children}</div>
    </PageContainer>
  );
}
